import React from 'react';
import './Apps.css';

const apps = [
  {
    name: 'Oraculus',
    tag: 'The Gateway to Global Data',
    description: 'A platform that helps you explore information beyond algorithmic control.\nInformation, unfiltered. Welcome to Oraculus.',
    url: 'https://oraculus.southlabs.ai',
    status: 'Closed Alpha',
    statusClass: 'app-status--alpha',
    cta: { text: 'Contact us to know more', scroll: true },
  },
  {
    name: 'Prompt Builder',
    tag: 'Prompt Wizard',
    description: 'A free tool for crafting, testing, and refining AI prompts. Helps teams standardize their prompt workflows and get consistent results from any AI model.',
    url: 'https://pb.southlabs.ai',
    status: 'Free',
    statusClass: 'app-status--free',
    cta: { text: 'Try it now!', href: 'https://pb.southlabs.ai' },
  },
];

function scrollToContact(e) {
  e.preventDefault();
  e.stopPropagation();
  const appEl  = document.querySelector('.App');
  const target = document.getElementById('contact');
  if (appEl && target) {
    appEl.scrollTo({ top: appEl.scrollTop + target.getBoundingClientRect().top, behavior: 'smooth' });
  }
}

function CardBody({ app }) {
  const { cta } = app;
  return (
    <>
      <div className="app-titlebar">
        <span className="app-titlebar-url">{app.url.replace('https://', '')}</span>
        <span className={`app-status${app.statusClass ? ` ${app.statusClass}` : ''}`}>{app.status}</span>
      </div>
      <div className="app-body">
        <span className="app-tag">{app.tag}</span>
        <h3 className="app-name">{app.name}</h3>
        <p className="app-description" style={{ whiteSpace: 'pre-line' }}>{app.description}</p>
        <div className="app-cta-row">
          {cta.scroll ? (
            <button className="btn-ghost-dim" onClick={scrollToContact}>
              {cta.text}
            </button>
          ) : (
            <a className="btn-ghost-dim" href={cta.href} target="_blank" rel="noopener noreferrer">
              {cta.text}
            </a>
          )}
        </div>
      </div>
    </>
  );
}

function Apps() {
  return (
    <section className="apps section" id="apps">
      <div className="container">
        <div className="section-header">
          <p className="section-label"><span className="section-prompt">&gt;</span> Our Apps</p>
          <h2 className="section-title">Built by us, for you</h2>
          <p className="section-subtitle">
            Bespoke AI systems integrating exclusive data streams for decisive intelligence.
          </p>
        </div>
        <div className="apps-grid">
          {apps.map((app) => (
            <div key={app.name} className="app-card app-card--static">
              <CardBody app={app} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Apps;
